import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import ContactForm from "../../components/ContactForm";

const AboutUsPage = () => {
  const { t, i18n } = useTranslation("about_us");
  const isAr = (i18n.language || "ar").startsWith("ar");

  useEffect(() => {
    document.title = 'DIDA MAX — About Us';
  }, []);
  return (
    <div style={{ ...styles.page, direction: isAr ? "rtl" : "ltr" }}>
      <div style={styles.container}>
        {/* Header Section */}
        <div style={styles.header}>
          <h1 style={styles.title}>{t("title")}</h1>
          <p style={styles.subtitle}>{t("subtitle")}</p>
        </div>

        {/* About Us Section */}
        <section style={styles.card}>
          <h2 style={styles.h2}>{t("about_section_title")}</h2>
          <p style={styles.p}>{t("about_section_body")}</p>
        </section>

        {/* Mission Section */}
        <section style={styles.card}>
          <h2 style={styles.h2}>{t("mission_title")}</h2>
          <p style={styles.p}>{t("mission_body")}</p>
        </section>

        {/* Vision Section */}
        <section style={styles.card}>
          <h2 style={styles.h2}>{t("vision_title")}</h2>
          <p style={styles.p}>{t("vision_body")}</p>
        </section>

        {/* Values Section */}
        <section style={styles.card}>
          <h2 style={styles.h2}>{t("values_title")}</h2>
          <Grid container spacing={2}>
            {Object.keys(t("values", { returnObjects: true })).map((key) => (
              <Grid item xs={12} sm={6} md={6} key={key}>
                <Card style={styles.valueCard}>
                  <CardContent>
                    <h3 style={styles.valueTitle}>
                      {t(`values.${key}.title`)}
                    </h3>
                    <p style={styles.valueDescription}>
                      {t(`values.${key}.description`)}
                    </p>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </section>

        {/* Products Section */}
        <section style={styles.card}>
          <h2 style={styles.h2}>{t("products_section_title")}</h2>
          <p style={styles.p}>{t("products_section_body")}</p>
          <ul style={styles.ul}>
            {t("products", { returnObjects: true }).map((product, index) => (
              <li key={index} style={styles.li}>
                {product}
              </li>
            ))}
          </ul>
        </section>

        {/* Why Choose Us Section */}
        <section style={styles.card}>
          <h2 style={styles.h2}>{t("why_choose_us_title")}</h2>
          <ul style={styles.ul}>
            {t("why_choose_us", { returnObjects: true }).map((reason, index) => (
              <li key={index} style={styles.li}>
                {reason}
              </li>
            ))}
          </ul>
        </section>

        {/* Experience Section */}
        <section style={styles.card}>
          <h2 style={styles.h2}>{t("experience_title")}</h2>
          <p style={styles.p}>{t("experience_body")}</p>
        </section>

        {/* Contact Section */}
        <section style={styles.card}>
          <h2 style={styles.h2}>{t("contact_us_title")}</h2>
          <p style={styles.p}>{t("contact_us_body")}</p>
          <Box sx={{ mt: 2 }}>
            <ContactForm />
          </Box>
        </section>

        {/* Footer Note */}
        <div style={styles.footerNote}>
          <p style={styles.thankYou}>{t("thank_you")}</p>
        </div>
      </div>
    </div>
  );
};

// Styles
const styles = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
    padding: "40px 20px",
  },
  container: {
    maxWidth: "1000px",
    margin: "0 auto",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
  },
  header: {
    backgroundColor: "#1976d2",
    color: "#fff",
    padding: "40px 30px",
    textAlign: "center",
  },
  title: {
    fontSize: "42px",
    fontWeight: "bold",
    margin: "0 0 15px 0",
    letterSpacing: "0.5px",
  },
  subtitle: {
    fontSize: "18px",
    fontWeight: "300",
    margin: "0",
    opacity: 0.9,
  },
  card: {
    padding: "30px",
    borderBottom: "1px solid #e0e0e0",
  },
  lastCard: {
    borderBottom: "none",
  },
  h2: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#1976d2",
    marginBottom: "20px",
    marginTop: "0",
  },
  p: {
    fontSize: "16px",
    lineHeight: "1.8",
    color: "#333",
    margin: "15px 0",
  },
  ul: {
    listStylePosition: "inside",
    paddingLeft: "20px",
    marginTop: "20px",
    marginBottom: "20px",
  },
  li: {
    fontSize: "16px",
    lineHeight: "1.8",
    color: "#555",
    marginBottom: "12px",
  },
  valueCard: {
    height: "100%",
    backgroundColor: "#f0f7ff",
    borderLeft: "4px solid #1976d2",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
  },
  valueTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#1976d2",
    margin: "0 0 10px 0",
  },
  valueDescription: {
    fontSize: "14px",
    color: "#555",
    margin: "0",
    lineHeight: "1.6",
  },
  footerNote: {
    backgroundColor: "#f5f5f5",
    padding: "20px 30px",
    textAlign: "center",
    borderTop: "1px solid #e0e0e0",
  },
  thankYou: {
    fontSize: "18px",
    fontWeight: "500",
    color: "#1976d2",
    margin: "0",
  },
};

export default AboutUsPage;
